import SectionStatusInfo from './SectionStatusInfo';

export default class Section<TSectionName extends string> {
	public name: TSectionName | null = null;
	public friendlyName: string | null = null;
	public status: SectionStatusInfo | null = null;
	public isEditable: boolean | null = null;

	public constructor() {

	}
};